module.exports = __webpack_public_path__ + "static/img/4-3.c9a87d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/4-3.jpg
// module id = YzmZ
// module chunks = 0